<h1 *ngIf="level === 1">{{ text }}</h1>
<h2 *ngIf="level === 2">{{ text }}</h2>
<h3 *ngIf="level === 3">{{ text }}</h3>
<h4 *ngIf="level === 4">{{ text }}</h4>
<h5 *ngIf="level === 5">{{ text }}</h5>
<h6 *ngIf="level === 6">{{ text }}</h6>
